import { Button } from "../../components/common";
import { ContactSupportModal, ChangeEmailModal } from "../../components/modals";

type UserContacts = {
  email?: string;
  phone?: string;
};

export const settingsList = (user: UserContacts) => {
  return [
    {
      id: "email",
      icon: "Mail",
      label: "Email",
      value: user.email,
      action: (
        <ChangeEmailModal>
          {(action) => (
            <Button
              variant={Button.variant.TERTIARY}
              className="ml-auto !p-2 !md:p-4"
              onClick={action}
            >
              Change
            </Button>
          )}
        </ChangeEmailModal>
      ),
    },
    {
      id: "phone",
      icon: "Mobile",
      label: "Mobile number",
      value: user.phone,
      hint: "We use your mobile number only for important updates on your invoices",
      action: (
        <ContactSupportModal
          title="Send request to customer support"
          subtitle="Right now we can only change your phone number via our support service."
        >
          {(action) => (
            <Button
              variant={Button.variant.TERTIARY}
              className="ml-auto !p-2 !md:p-4"
              onClick={action}
            >
              Change
            </Button>
          )}
        </ContactSupportModal>
      ),
    },
  ];
};
